module.exports = __webpack_public_path__ + "static/img/club-portal-bg.e82e872.png";